import React from 'react';
import PropTypes from 'prop-types';
import { BaseButton, ButtonGroup, Flex } from '@common/components';

export function BottomActionBar({
  cancelText,
  onCancel,
  actionText,
  onAction,
  showActionButton,
  confirmLoading,
}) {
  return (
    <Flex justify="end">
      <ButtonGroup>
        <BaseButton size="large" onClick={onCancel}>
          {cancelText}
        </BaseButton>

        {showActionButton && (
          <BaseButton
            type="primary"
            size="large"
            onClick={onAction}
            loading={confirmLoading}
          >
            {actionText}
          </BaseButton>
        )}
      </ButtonGroup>
    </Flex>
  );
}

BottomActionBar.propTypes = {
  cancelText: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  actionText: PropTypes.string.isRequired,
  onAction: PropTypes.func.isRequired,
  showActionButton: PropTypes.bool,
  confirmLoading: PropTypes.bool,
};
